(function(){
if(window.__bqh) return; window.__bqh=1;
if(!document.querySelector('.shopify-section.bqh')) return;
function bqRun(){

  // thema-editor: alles direct zichtbaar
  try{ if(window.Shopify&&Shopify.designMode){ document.documentElement.classList.add('bq-design'); }
    document.addEventListener('shopify:section:load',function(ev){ ev.target.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');}); });
  }catch(e){}

try{
  // announcement bar, één melding tegelijk
  var slides = document.querySelectorAll('#annSlides .slide');
  var idx = 0, timer;
  function show(n){
    slides[idx].classList.remove('is-on');
    idx = (n + slides.length) % slides.length;
    slides[idx].classList.add('is-on');
  }
  function start(){ timer = setInterval(function(){ show(idx + 1); }, 4000); }
  function restart(){ clearInterval(timer); start(); }
  document.getElementById('annNext').addEventListener('click', function(){ show(idx + 1); restart(); });
  document.getElementById('annPrev').addEventListener('click', function(){ show(idx - 1); restart(); });
  start();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // mobiel menu

}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // reviews: doorlopend, na de laatste komt de eerste weer
  (function(){
    var row=document.getElementById('rvRow'); if(!row) return;
    var originals=[].slice.call(row.children);
    var n=originals.length;
    function clone(el){ var c=el.cloneNode(true); c.setAttribute('aria-hidden','true'); c.querySelectorAll('a,button').forEach(function(x){x.setAttribute('tabindex','-1');}); if(c.tagName==='A') c.setAttribute('tabindex','-1'); return c; }
    originals.forEach(function(el){ row.appendChild(clone(el)); });
    originals.slice().reverse().forEach(function(el){ row.insertBefore(clone(el), row.firstChild); });
    function setWidth(){ var a=row.children[n], b=row.children[2*n]; return b.offsetLeft - a.offsetLeft; }
    function jumpTo(x){ row.style.scrollBehavior='auto'; row.style.scrollSnapType='none'; row.scrollLeft=x; row.offsetHeight; row.style.scrollSnapType=''; row.style.scrollBehavior=''; }
    function toStart(){ jumpTo(row.children[n].offsetLeft - row.children[0].offsetLeft); }
    toStart();
    window.addEventListener('resize', toStart);
    var t;
    row.addEventListener('scroll', function(){
      clearTimeout(t);
      t=setTimeout(function(){
        var w=setWidth(), start=row.children[n].offsetLeft-row.children[0].offsetLeft;
        if(row.scrollLeft < start - w*0.5) jumpTo(row.scrollLeft + w);
        else if(row.scrollLeft > start + w*0.5) jumpTo(row.scrollLeft - w);
      },140);
    },{passive:true});
    function step(d){ var c=row.children[n]; var gap=parseFloat(getComputedStyle(row).columnGap)||16; row.scrollBy({left:d*(c.getBoundingClientRect().width+gap),behavior:'smooth'}); }
    document.getElementById('rvPrev').addEventListener('click',function(){step(-1);});
    document.getElementById('rvNext').addEventListener('click',function(){step(1);});
  })();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // zeven modi: rail met pijltjes en voortgangsbalk
  (function(){
    var rail=document.getElementById('mRail'); if(!rail) return;
    var bar=document.getElementById('mBar');
    function update(){ var max=rail.scrollWidth-rail.clientWidth; var r=max>0?rail.scrollLeft/max:1; var min=rail.clientWidth/rail.scrollWidth; bar.style.width=Math.round((min+(1-min)*r)*100)+'%'; }
    function step(d){ var c=rail.querySelector('.m-card'); rail.scrollBy({left:d*(c.getBoundingClientRect().width+16),behavior:'smooth'}); }
    rail.addEventListener('scroll',function(){ window.requestAnimationFrame(update); },{passive:true});
    window.addEventListener('resize',update);
    document.getElementById('mPrev').addEventListener('click',function(){step(-1);});
    document.getElementById('mNext').addEventListener('click',function(){step(1);});
    update();
  })();

  var btn = document.getElementById('menuBtn');
  var nav = document.getElementById('mobileNav');
  btn.addEventListener('click', function () {
    var open = nav.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (typeof headerState === 'function') headerState();
  });
  nav.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') { nav.classList.remove('open'); btn.setAttribute('aria-expanded','false'); if (typeof headerState === 'function') headerState(); }
  });



}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // header: transparant over de hero, wit zodra je scrolt of het menu opent
  var siteHeader = document.getElementById('siteHeader');
  function headerState(){
    var menuOpen = document.getElementById('mobileNav').classList.contains('open');
    var heroEl = document.querySelector('.hero');
    var pastHero = heroEl ? heroEl.getBoundingClientRect().bottom <= 80 : window.scrollY > 600;
    siteHeader.classList.toggle('solid', pastHero || menuOpen);
  }
  window.addEventListener('scroll', headerState, { passive:true });
  headerState();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // zeven modi: het beeld volgt de modus die in beeld is
  (function(){
    var modes = document.querySelectorAll('.mode');
    var frames = document.querySelectorAll('.modes-visual .frame');
    var mvNum = document.getElementById('mvNum');
    var mvName = document.getElementById('mvName');
    if (!modes.length) return;
    function activate(i){
      modes.forEach(function(m){ m.classList.toggle('is-active', +m.getAttribute('data-i') === i); });
      frames.forEach(function(f){ f.style.opacity = (+f.getAttribute('data-mode') === i) ? '1' : '0'; });
      mvNum.innerHTML = String(i + 1).padStart(2,'0') + '<span>/07</span>';
      mvName.textContent = modes[i].querySelector('h3').textContent;
    }
    if ('IntersectionObserver' in window) {
      var mo = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if (en.isIntersecting) activate(+en.target.getAttribute('data-i')); });
      }, { rootMargin:'-45% 0px -45% 0px' });
      modes.forEach(function(m){ mo.observe(m); });
    }
    modes.forEach(function(m){ m.addEventListener('mouseenter', function(){ activate(+m.getAttribute('data-i')); }); });
  })();


}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // productfoto's: swipen, pijltjes en bolletjes
  (function(){
    var track=document.getElementById('gTrack');
    if(!track) return;
    var slides=track.querySelectorAll('.g-slide');
    var dots=document.querySelectorAll('#gDots .g-dot');
    function current(){ return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i){ i=(i+slides.length)%slides.length; track.scrollTo({left:i*track.clientWidth,behavior:'smooth'}); }
    function sync(){ var i=current(); dots.forEach(function(d,k){ d.classList.toggle('is-on',k===i); }); }
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(sync); }, {passive:true});
    document.getElementById('gPrev').addEventListener('click', function(){ go(current()-1); });
    document.getElementById('gNext').addEventListener('click', function(){ go(current()+1); });
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ go(k); }); });
    track.addEventListener('keydown', function(e){
      if(e.key==='ArrowRight'){ e.preventDefault(); go(current()+1); }
      if(e.key==='ArrowLeft'){ e.preventDefault(); go(current()-1); }
    });
  })();




}catch(e){ if(window.console) console.warn("bq",e); }
try{
  // rustige fade-in bij scrollen
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

}catch(e){ if(window.console) console.warn("bq",e); }


}
if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",bqRun); else bqRun();
})();
